import React, { useEffect, useState } from 'react'
import { Badge, Button } from 'reactstrap'
import { useResponse } from '../../../../hooks/useResponse';
import { createNegativeHoursCollection } from '../../../../api/collections';
import ResultHandler from '../../../../components/ResultHandler';
import { useHistory } from 'react-router-dom';

const AddNegativeHours = ({ finalData }) => {
  let navigate = useHistory()
  const [data, setData] = useState(null);
  const [checkedCount, setCheckedCount] = useState(1)

  useEffect(() => {
    setData({
      ...finalData,
      id: undefined,
      hours: finalData.hours.map(hour => ({
        ...hour,
        id: undefined,
        hoursLength: hour.periods?.filter(period => period.checked)
          .map(period => period.length || 0)
          .reduce((acc, periodLength) => acc + periodLength, 0),
        periods: hour.periods?.map(period => {
          if(period.checked) {
            return {...period, id: undefined}
          } else {
            return {}
          }
        })
      }))
    })
  }, [finalData])

  useEffect(() => {
    const count = finalData.hours.reduce((total, hour) => {
      return total + hour.periods.filter(period => period.checked).length;
    }, 0);

    setCheckedCount(count);
  }, [data])
  
  const { setData: create, loading, error, success } = useResponse(createNegativeHoursCollection, () => {
    navigate.goBack()
  })
  
  const handleCreateNegativeHours = () => {
    create({ data: data, type: "add" })
  }
  

  return (
    <>
      {checkedCount > 0 && ( <>
        <div className="mb-2 mt-4 d-flex gap-2 justify-content-end">
          <Badge color="dark" className="d-flex align-items-center px-2 py-1" style={{ fontSize: "13px" }}>
            {checkedCount} selected
          </Badge>

          <Button color="dark" className="fw-bold px-2 py-1" onClick={handleCreateNegativeHours} disabled={loading}>
            {loading ? 'Loading...' : 'Create Negative Hours'}
          </Button>

        </div>

        <ResultHandler
          // loading={true}
          error={error}
          success={success}
          successMsg={"Successfully!"}
        />
      </>)}
    </>
  )
}

export default AddNegativeHours;



  // const handleUnselectAll = () => {
  //   const newData = {
  //     ...data,
  //     hours: data.hours.map(hour => ({
  //       ...hour,
  //       periods: hour.periods.map(period => ({
  //         ...period,
  //         checked: false
  //       }))
  //     }))
  //   };
  //   setData(newData);
  // };

  
            {/* <span style={{ opacity: "0.5", margin: "0px 6px" }}>|</span>
            <i
              style={{ cursor: "pointer" }}
              className="mdi mdi-close"
              onClick={handleUnselectAll}
            ></i> */}
